import { chakra } from '@plurall/elo-v3';

import {
  gaugeChartAreaRecipe,
  gaugeChartCenterContentRecipe,
  gaugeChartCenterRecipe,
  gaugeChartContentRecipe,
  gaugeChartLegendColorRecipe,
  gaugeChartLegendItemRecipe,
  gaugeChartLegendRecipe,
  gaugeChartTotalRecipe,
  gaugeChartValueRecipe,
  gaugeChartWrapperRecipe,
} from './GaugeChart.recipe';

export const GaugeChartWrapperFactory = chakra('div', gaugeChartWrapperRecipe);
export const GaugeChartContentFactory = chakra('div', gaugeChartContentRecipe);
export const GaugeChartAreaFactory = chakra('div', gaugeChartAreaRecipe);
export const GaugeChartCenterFactory = chakra('div', gaugeChartCenterRecipe);
export const GaugeChartCenterContentFactory = chakra('div', gaugeChartCenterContentRecipe);
export const GaugeChartValueFactory = chakra('div', gaugeChartValueRecipe);
export const GaugeChartTotalFactory = chakra('div', gaugeChartTotalRecipe);
export const GaugeChartLegendFactory = chakra('div', gaugeChartLegendRecipe);
export const GaugeChartLegendItemFactory = chakra('div', gaugeChartLegendItemRecipe);
export const GaugeChartLegendColorFactory = chakra('span', gaugeChartLegendColorRecipe);
